document.addEventListener('DOMContentLoaded', (event) => {
    // Load state from new Vercel API
    function loadSavedProducts() {
        const buttons = document.querySelectorAll('.save_product_button[data-customer-id]');
        if (buttons.length === 0) return;

        const customerId = buttons[0].getAttribute('data-customer-id');

        if (!customerId) {
            return;
        }

        fetch(`https://clnf.vercel.app/api/product-wishlist/get?customerId=${customerId}`)
            .then(res => res.json())
            .then(response => {
                // Handle array or object structure
                let items = Array.isArray(response) ? response : (response.wishlist || response.products || response.data || []);

                if (items && items.length > 0) {
                    var markedSet = new Set();
                    items.forEach(function (item) {
                        var productId = item.productId || item.product_id;

                        // We use product ID for the main check
                        if (productId && !markedSet.has(productId)) {
                            // Find buttons for this product
                            const productButtons = document.querySelectorAll(`.save_product_button[data-product-id="${productId}"]`);
                            productButtons.forEach(btn => {
                                btn.classList.add('active');
                                const icon = btn.querySelector('i, svg.wishlist-icon, svg');
                                if (icon) {
                                    if (icon.tagName.toLowerCase() === 'svg') {
                                        icon.classList.add('filled');
                                        icon.setAttribute('fill', 'currentColor');
                                    } else {
                                        icon.classList.remove('fa-heart-o');
                                        icon.classList.add('fa-heart');
                                    }
                                }
                                const text = btn.querySelector('.save-text');
                                if (text && !text.classList.contains('sr-only')) {
                                    text.textContent = 'Saved';
                                }
                            });

                            markedSet.add(productId);
                        }
                    });
                }
            })
            .catch(error => {
                console.error('Error loading saved products:', error);
            });
    }

    loadSavedProducts();

    // Event Delegation for dynamic elements
    document.addEventListener('click', async function (e) {
        // Handle click on button or its children
        const btn = e.target.closest('.save_product_button');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation(); // Stop propagation just in case

        let isAdding = !btn.classList.contains('active');
        const productId = btn.getAttribute('data-product-id');

        // Optimistic UI update immediately
        const allButtonsForProduct = document.querySelectorAll(`.save_product_button[data-product-id="${productId}"]`);
        allButtonsForProduct.forEach(b => {
            updateButtonState(b, isAdding);
        });

        // Helper to update button state
        function updateButtonState(b, active) {
            if (active) {
                b.classList.add('active');
                const icon = b.querySelector('i, svg.wishlist-icon, svg');
                if (icon) {
                    if (icon.tagName.toLowerCase() === 'svg') {
                        icon.classList.add('filled');
                        icon.setAttribute('fill', 'currentColor');
                    } else {
                        icon.classList.remove('fa-heart-o');
                        icon.classList.add('fa-heart');
                    }
                }
                const text = b.querySelector('.save-text');
                if (text && !text.classList.contains('sr-only')) {
                    text.textContent = 'Saved';
                }
            } else {
                b.classList.remove('active');
                const icon = b.querySelector('i, svg.wishlist-icon, svg');
                if (icon) {
                    if (icon.tagName.toLowerCase() === 'svg') {
                        icon.classList.remove('filled');
                        icon.setAttribute('fill', 'none');
                    } else {
                        icon.classList.remove('fa-heart');
                        icon.classList.add('fa-heart-o');
                    }
                }
                const text = b.querySelector('.save-text');
                if (text && !text.classList.contains('sr-only')) {
                    text.textContent = 'Add to Wishlist';
                }
            }
        }

        // --- ROBUST DATA GATHERING START ---
        let variantId = btn.getAttribute('data-variant-id');
        let productTitle = btn.getAttribute('data-product-title');
        let productHandle = btn.getAttribute('data-product-handle');
        let productImage = btn.getAttribute('data-product-image');
        let productUrl = btn.getAttribute('data-product-url');
        let productPrice = btn.getAttribute('data-product-price');

        if (window.ClnfWishlistData && window.ClnfWishlistData[productId]) {
            const globalData = window.ClnfWishlistData[productId];
            let gImage = globalData.image;
            if (gImage && gImage.startsWith('//')) {
                gImage = 'https:' + gImage;
            }
            if (globalData.title) productTitle = globalData.title;
            if (globalData.handle) productHandle = globalData.handle;
            if (gImage) productImage = gImage;
            if (globalData.url) productUrl = globalData.url;
            if (globalData.price) productPrice = globalData.price;
            if ((!variantId || variantId === 'null') && globalData.variantId) {
                variantId = globalData.variantId;
            }
        }

        if (!productHandle) {
            if (productUrl) {
                const match = productUrl.match(/\/products\/([^\/\?]+)/);
                if (match) productHandle = match[1];
            }
            if (!productHandle && window.location.pathname.includes('/products/')) {
                const match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
                if (match) productHandle = match[1];
            }
            if (!productHandle) {
                const container = btn.closest('.grid-view-item') || btn.closest('.product-single-wrapper') || btn.closest('.grid__item') || document.body;
                const links = container.querySelectorAll('a[href*="/products/"]');
                for (let link of links) {
                    const href = link.getAttribute('href');
                    const match = href.match(/\/products\/([^\/\?]+)/);
                    if (match) {
                        productHandle = match[1];
                        break;
                    }
                }
            }
        }

        if (isAdding && productHandle && (!productTitle || !productImage || !productPrice)) {
            try {
                const response = await fetch(`/products/${productHandle}.js`);
                if (response.ok) {
                    const productData = await response.json();
                    if (!productTitle) productTitle = productData.title;
                    if (!productImage) productImage = "https:" + productData.featured_image;
                    if (!productPrice) productPrice = (productData.price / 100).toFixed(2);
                    if (!productUrl) productUrl = productData.url;
                    if (!variantId && productData.variants && productData.variants.length > 0) {
                        variantId = productData.variants[0].id;
                    }
                }
            } catch (err) {
                console.error("Failed to fetch robust product details:", err);
            }
        }

        if (!productTitle || !productPrice) {
            const container = btn.closest('.grid-view-item') || btn.closest('.product-single-wrapper') || document.body;
            if (!productTitle) {
                const titleEl = container.querySelector('.product-grid--title a, .product-details-product-title, h1.product_title');
                if (titleEl) productTitle = titleEl.innerText.trim();
            }
            if (!productPrice) {
                const priceEl = container.querySelector('.product-grid--price .money, #ComparePrice .money, .price .money');
                if (priceEl) productPrice = priceEl.innerText.trim();
            }
        }

        if (!variantId || variantId === "null" || variantId === "") {
            variantId = productId;
        }

        let customerId = btn.getAttribute('data-customer-id');
        if (!customerId || customerId === "") {
            const pendingItem = {
                productId,
                variantId,
                productHandle,
                productTitle,
                productImage,
                productPrice,
                productUrl,
                timestamp: Date.now()
            };
            localStorage.setItem('pendingWishlistItem', JSON.stringify(pendingItem));
            window.location.href = '/account/login';
            return;
        }

        let apiUrl = isAdding ? 'https://clnf.vercel.app/api/product-wishlist/add' : 'https://clnf.vercel.app/api/product-wishlist/remove';
        let method = isAdding ? 'POST' : 'DELETE';

        let body = {};
        if (method === 'DELETE') {
            body = {
                customerId: Number(customerId),
                customer_id: Number(customerId),
                productId: Number(productId),
                product_id: Number(productId),
                variantId: Number(variantId),
                variant_id: Number(variantId)
            };
        } else {
            body = {
                customerId: Number(customerId),
                customer_id: Number(customerId),
                productId: Number(productId),
                product_id: Number(productId),
                variantId: Number(variantId),
                variant_id: Number(variantId),
                handle: productHandle,
                product_handle: productHandle,
                title: productTitle,
                product_title: productTitle,
                image: productImage,
                product_image: productImage,
                url: productUrl,
                product_url: productUrl,
                price: productPrice,
                product_price: productPrice
            };
        }

        fetch(apiUrl, {
            method: method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
            .then(async res => {
                if (res.status === 204) {
                    return {};
                }
                if (!res.ok) {
                    let errorMessage = 'Network response was not ok';
                    try {
                        const errorData = await res.json();
                        errorMessage = errorData.error || errorData.message || errorMessage;
                    } catch (e) { }
                    throw new Error(errorMessage);
                }
                return res.json();
            })
            .then(response => {
                if (!isAdding && btn.closest('.wishlist-product-row')) {
                    const row = btn.closest('.wishlist-product-row');
                    row.style.opacity = '0';
                    setTimeout(() => row.remove(), 300);
                }
            })
            .catch(error => {
                console.error("Wishlist update failed:", error);
                allButtonsForProduct.forEach(b => {
                    updateButtonState(b, !isAdding);
                });
                alert('Something went wrong updating your wishlist. Please try again.');
            });
    });

    function checkPendingWishlistItems() {
        const pendingItemJson = localStorage.getItem('pendingWishlistItem');
        if (!pendingItemJson) return;

        let customerId = null;
        if (typeof window.customer !== 'undefined') {
            customerId = window.customer;
        }
        if (!customerId && window.__st && window.__st.cid) {
            customerId = window.__st.cid;
        }
        if (!customerId) {
            const buttons = document.querySelectorAll('.save_product_button[data-customer-id]');
            if (buttons.length > 0) {
                customerId = buttons[0].getAttribute('data-customer-id');
            }
        }
        if (!customerId) return;

        try {
            const pendingItem = JSON.parse(pendingItemJson);
            const ONE_HOUR = 60 * 60 * 1000;
            if (Date.now() - pendingItem.timestamp > ONE_HOUR) {
                localStorage.removeItem('pendingWishlistItem');
                return;
            }

            const body = {
                customerId: Number(customerId),
                customer_id: Number(customerId),
                productId: Number(pendingItem.productId),
                product_id: Number(pendingItem.productId),
                variantId: Number(pendingItem.variantId),
                variant_id: Number(pendingItem.variantId),
                handle: pendingItem.productHandle,
                product_handle: pendingItem.productHandle,
                title: pendingItem.productTitle,
                product_title: productTitle,
                image: pendingItem.productImage,
                product_image: pendingItem.productImage,
                url: pendingItem.productUrl,
                product_url: pendingItem.productUrl,
                price: pendingItem.productPrice,
                product_price: pendingItem.productPrice
            };

            fetch('https://clnf.vercel.app/api/product-wishlist/add', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then(async res => {
                    if (!res.ok) {
                        let errorMessage = 'Network response was not ok';
                        try {
                            const errorData = await res.json();
                            errorMessage = errorData.error || errorData.message || errorMessage;
                        } catch (e) { }
                        throw new Error(errorMessage);
                    }
                    return res.json();
                })
                .then(data => {
                    localStorage.removeItem('pendingWishlistItem');
                    if (window.location.pathname === '/account') {
                        window.location.reload();
                    }

                    const allButtonsForProduct = document.querySelectorAll(`.save_product_button[data-product-id="${pendingItem.productId}"]`);
                    allButtonsForProduct.forEach(b => {
                        b.classList.add('active');
                        const icon = b.querySelector('i, svg.wishlist-icon, svg');
                        if (icon) {
                            if (icon.tagName.toLowerCase() === 'svg') {
                                icon.classList.add('filled');
                                icon.setAttribute('fill', 'currentColor');
                            } else {
                                icon.classList.remove('fa-heart-o');
                                icon.classList.add('fa-heart');
                            }
                        }
                    });
                })
                .catch(err => {
                    console.error("Failed to add pending wishlist item:", err);
                    localStorage.removeItem('pendingWishlistItem');
                });
        } catch (e) {
            console.error("Error parsing pending wishlist item:", e);
            localStorage.removeItem('pendingWishlistItem');
        }
    }

    checkPendingWishlistItems();
});
